import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { DownloadState } from './download.state';
import { DownloadStateModel } from './download.state-model';

@Injectable()
export class DownloadSelectors {
  @Selector([DownloadState])
  static isDownloading(state: DownloadStateModel): boolean {
    return state.isDownloading;
  }
}
